var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9736",
    "data-name": "Group 9736",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.167,
    height: 35.446,
    viewBox: "0 0 26.167 35.446",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3956",
    "data-name": "Rectangle 3956",
    width: 26.167,
    height: 35.446,
    fill: "#fff",
    stroke: "#519a7f",
    strokeWidth: 0.3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9735",
    "data-name": "Group 9735",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33159",
    "data-name": "Path 33159",
    d: "M14.233,0c.465.092.939.155,1.394.283.907.255,1.823.5,2.7.834a11.1,11.1,0,0,1,3.031,1.834,13.221,13.221,0,0,1,2.379,2.54,12.862,12.862,0,0,1,2.415,6.989,13.185,13.185,0,0,1-1.874,7.263c-.855,1.5-1.826,2.937-2.777,4.381-2.27,3.449-4.561,6.883-6.835,10.329a1.882,1.882,0,0,1-1.609.994,1.72,1.72,0,0,1-1.462-.922q-3.086-4.655-6.172-9.31Q3.882,22.878,2.375,20.52a16.127,16.127,0,0,1-2.136-5.3,10.472,10.472,0,0,1-.177-3.369A13.08,13.08,0,0,1,2.686,5.2,13.242,13.242,0,0,1,7.033,1.5,14.053,14.053,0,0,1,11.139.14c.269-.049.54-.093.809-.14ZM12.994,1.591a10.589,10.589,0,0,0-3.743.62A11.146,11.146,0,0,0,4.938,4.928,14.015,14.015,0,0,0,3.317,7.015a10.945,10.945,0,0,0-1.741,5.2,9.459,9.459,0,0,0,.185,2.719,14.29,14.29,0,0,0,1.948,4.827c1.142,1.818,2.336,3.6,3.519,5.395q2.8,4.237,5.607,8.464c.224.338.335.343.551.013.511-.781,1.013-1.568,1.527-2.346q3.46-5.234,6.923-10.467a15.741,15.741,0,0,0,2.142-4.162,15.5,15.5,0,0,0,.617-2.8,14.882,14.882,0,0,0-.118-2.557,8.582,8.582,0,0,0-.81-2.856,10.336,10.336,0,0,0-2.838-3.869,15.666,15.666,0,0,0-2.266-1.624,10.8,10.8,0,0,0-5.569-1.351",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#519a7f",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33160",
    "data-name": "Path 33160",
    d: "M51.293,58.859a7.288,7.288,0,0,1,2.4-5.892A6.519,6.519,0,0,1,58.148,51.3a6.812,6.812,0,0,1,4.935,1.994,6.672,6.672,0,0,1,2.07,4.9,6.96,6.96,0,0,1-7.194,6.947c-3.52-.073-6.751-3.2-6.665-6.283M63.57,58.2a5.37,5.37,0,0,0-10.73-.317,5.372,5.372,0,1,0,10.73.317",
    transform: "translate(-45.114 -45.119)",
    fill: "#fff",
    stroke: "#519a7f",
    strokeWidth: 0.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.cc25940f3ed359e9f34faf32c5b6c7ee.svg";
export { ForwardRef as ReactComponent };